import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { CS_REVIEW_PAGE_NAME } from '../../../constants/service/app/csReviewConstants';
import CsReviewCreateWrap from '../../../views/cs/review/create/CsReviewCreateWrap';

const CsReviewCreate = () => {
  return (
    <PageTemplate pageName={CS_REVIEW_PAGE_NAME.REVIEW_CREATE}>
      <CsReviewCreateWrap />
    </PageTemplate>
  );
};

export default CsReviewCreate;
